module.exports = __webpack_public_path__ + "img/79.c13cca1d.png";